import { SET_DEVICES_FILTERS, SET_SIMCARDS_FILTERS, SET_GPS_FILTERS } from '../actions/filters';

const initialState = {
    devices: { search: '', from_created: '', to_created: '', status: {}, substatus: {}, enabled: '' },
    simcards: {
        search: '',
        from_created: '',
        to_created: '',
        status: '',
        substatus: '',
        enabled: ''
    },
    gps: {
        date: '',
        from_created: '',
        to_created: '',
        search: '',
        imei: '',
        simcard: '',
        status: {},
        assigned: {},
        substatus: {},
        enabled: {},
        protocol: ''
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_DEVICES_FILTERS: {
            return {
                ...state,
                devices: {
                    search: action.payload.search,
                    from_created: action.payload.from_created,
                    to_created: action.payload.to_created,
                    status: action.payload.status,
                    substatus: action.payload.substatus,
                    enabled: action.payload.enabled
                }
            };
        }
        case SET_SIMCARDS_FILTERS: {
            return {
                ...state,
                simcards: {
                    search: action.payload.search,
                    from_created: action.payload.from_created,
                    to_created: action.payload.to_created,
                    status: action.payload.status,
                    substatus: action.payload.substatus,
                    enabled: action.payload.enabled
                }
            };
        }
        case SET_GPS_FILTERS: {
            return {
                ...state,
                gps: {
                    search: action.payload.search,
                    from_created: action.payload.from_created,
                    to_created: action.payload.to_created,
                    status: action.payload.status,
                    enabled: action.payload.enabled,
                    protocol: action.payload.protocol,
                    substatus: action.payload.substatus,
                    date: action.payload.date,
                    imei: action.payload.imei,
                    simcard: action.payload.simcard,
                    assigned: action.payload.assigned,
                }
            };
        }
        default:
            return state;
    }
};
